import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdown', 'button', 'searchInput', 'optionsList'];
  static values = {
    submitOnSelect: { type: Boolean, default: true },
  };

  connect() {
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener('click', this.boundHandleOutsideClick, true);
    this.syncFromDOM();
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleOutsideClick, true);
  }

  toggle() {
    const isOpening = this.dropdownTarget.classList.contains('hidden');

    if (isOpening) {
      const checked = this.element.querySelector('input[type=radio]:checked');
      if (!checked) {
        const firstRadio = this.element.querySelector('input[type=radio]');
        if (firstRadio && firstRadio.value === '') {
          firstRadio.checked = true;
          this.updateButtonText(firstRadio.dataset.value);
          this.buttonTarget.classList.remove('text-black-400');
          this.buttonTarget.classList.add('text-black-1000');
        }
      }

      if (this.hasSearchInputTarget) {
        this.searchInputTarget.value = '';
        this.filterOptions();
        setTimeout(() => this.searchInputTarget.focus(), 100);
      }
    }

    this.dropdownTarget.classList.toggle('hidden');
    this.dropdownTarget.classList.toggle('opacity-0');
    this.dropdownTarget.classList.toggle('scale-95');
  }

  filterOptions() {
    if (!this.hasSearchInputTarget) return;

    const searchTerm = this.searchInputTarget.value.toLowerCase();
    const listItems = this.optionsListTarget.querySelectorAll('li');

    listItems.forEach((li) => {
      if (li.classList.contains('border-t')) {
        return;
      }

      const label = li.querySelector('span');
      if (label) {
        const text = label.textContent.toLowerCase();
        if (text.includes(searchTerm)) {
          li.style.setProperty('display', 'block', 'important');
        } else {
          li.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  selectOption(event) {
    const selectedValue = event.target.dataset.value || this.buttonTarget.dataset.placeholder;
    this.updateButtonText(selectedValue);

    if (selectedValue === this.buttonTarget.dataset.placeholder) {
      this.buttonTarget.classList.remove('text-black-1000');
      this.buttonTarget.classList.add('text-black-400');
    } else {
      this.buttonTarget.classList.remove('text-black-400');
      this.buttonTarget.classList.add('text-black-1000');
    }

    this.close();
    if (this.submitOnSelectValue) {
      this.submitForm();
    }
  }

  syncFromDOM() {
    const checked = this.element.querySelector('input[type=radio]:checked');
    const value = checked?.dataset.value || this.buttonTarget.dataset.placeholder;
    this.updateButtonText(value);

    if (value === this.buttonTarget.dataset.placeholder) {
      this.buttonTarget.classList.remove('text-black-1000');
      this.buttonTarget.classList.add('text-black-400');
    } else {
      this.buttonTarget.classList.remove('text-black-400');
      this.buttonTarget.classList.add('text-black-1000');
    }
  }

  updateButtonText(value) {
    this.buttonTarget.innerText = value;
    this.buttonTarget.dataset.inlineTooltipMessageValue = value;
  }

  submitForm() {
    const form = this.element.closest('form');
    if (form) {
      form.requestSubmit();
    }
  }

  close() {
    this.dropdownTarget.classList.add('hidden', 'opacity-0', 'scale-95');
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  clearSelection() {
    const radios = this.element.querySelectorAll('input[type=radio]');
    radios.forEach((radio) => (radio.checked = false));

    this.updateButtonText(this.buttonTarget.dataset.placeholder);
    this.buttonTarget.classList.remove('text-black-1000');
    this.buttonTarget.classList.add('text-black-400');

    this.close();
    if (this.submitOnSelectValue) {
      this.submitForm();
    }
    this.element.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
